import * as React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export const LocusVectorBotIcon = ({ color, fontSize }) => {
  return (
    <SvgIcon
      color={color ? color : ""}
      fontSize={fontSize ? fontSize : "medium"}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.8125 8H19.375C19.7188 8 20 8.28125 20 8.625C20 8.96875 19.7188 9.25 19.375 9.25H17.8125V12.4625C17.6125 12.4125 17.4062 12.375 17.1875 12.375C15.8062 12.375 14.6875 13.4937 14.6875 14.875H5.3125C5.3125 13.4937 4.19375 12.375 2.8125 12.375C2.59375 12.375 2.3875 12.4125 2.1875 12.4625V9.25H0.625C0.28125 9.25 0 8.96875 0 8.625C0 8.28125 0.28125 8 0.625 8H2.1875V4.25H0.625C0.28125 4.25 0 3.96875 0 3.625C0 3.28125 0.28125 3 0.625 3H19.375C19.7188 3 20 3.28125 20 3.625C20 3.96875 19.7188 4.25 19.375 4.25H17.8125V8ZM13.125 8H14.0625V4.25H5.9375V8H6.875L7.9875 6.2625C8.075 6.175 8.19375 6.125 8.31875 6.125H11.6813C11.8063 6.125 11.925 6.175 12.0125 6.2625L13.125 8ZM2.8125 16.4375C3.67544 16.4375 4.375 15.7379 4.375 14.875C4.375 14.0121 3.67544 13.3125 2.8125 13.3125C1.94956 13.3125 1.25 14.0121 1.25 14.875C1.25 15.7379 1.94956 16.4375 2.8125 16.4375ZM17.1875 16.4375C18.0504 16.4375 18.75 15.7379 18.75 14.875C18.75 14.0121 18.0504 13.3125 17.1875 13.3125C16.3246 13.3125 15.625 14.0121 15.625 14.875C15.625 15.7379 16.3246 16.4375 17.1875 16.4375Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
};
